import React from 'react';
import { Spinner } from 'src/ui/Spinner';

const LoadingPage = () => (
  <div
    style={{
      display: 'flex',
      height: '100vh',
      width: '100vw',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Spinner size="lg" />
  </div>
);

export default LoadingPage;
